module.exports = __webpack_public_path__ + "static/media/bottom_shape_3_mob.15a07a93.svg";